<template>
  <v-layout flex align-center justify-center>
    <v-flex xs12 sm8 elevation-6>
      <v-toolbar class="py-1 blue">
        <v-toolbar-title class="white--text">
          <h4>Life RTL Registration Page</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-dialog v-model="tcshowdialog" persistent>
        <v-card>
          <v-card-title class="headline">Terms and Conditions</v-card-title>
          <v-card-text>{{ tcmessage }}</v-card-text>
          <v-card-text>{{ tcmessagea }}</v-card-text>
          <v-card-text>{{ tcmessageb }}</v-card-text>
          <v-card-text>{{ tcmessagec }}</v-card-text>
          <v-card-text>
            <h3>Terms and Conditions for the use of Life RTL</h3>
          </v-card-text>
          <v-card-text>
            <h4>1. Membership</h4>
          </v-card-text>
          <v-card-text>{{ tcmessage1 }}</v-card-text>
          <v-card-text>{{ tcmessage1a }}</v-card-text>
          <v-card-text>{{ tcmessage1b }}</v-card-text>
          <v-card-text>
            <h4>2. Terms of Use</h4>
          </v-card-text>
          <v-card-text>{{ tcmessage2 }}</v-card-text>
          <v-card-text>{{ tcmessage2a }}</v-card-text>
          <v-card-text>{{ tcmessage2b }}</v-card-text>
          <v-card-text>
            <h4>3. Termination of Membership</h4>
          </v-card-text>
          <v-card-text>{{ tcmessage3 }}</v-card-text>
          <v-card-text>
            <h4>4. Changes</h4>
          </v-card-text>
          <v-card-text>{{ tcmessage4 }}</v-card-text>
          <v-card-text>
            <h4>5. Disclaimers</h4>
          </v-card-text>
          <v-card-text>{{ tcmessage5 }}</v-card-text>
          <v-card-text>{{ tcmessage5a }}</v-card-text>
          <v-card-text>{{ tcmessage5b }}</v-card-text>
          <v-card-text>{{ tcmessage5c }}</v-card-text>
          <v-card-text>{{ tcmessage5d }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-on:click="tcshowdialog = false">Agree</v-btn>
            <v-btn color="red" v-on:click="navigateRoute('/login')">Disagree and exit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <v-card-text class="pt-4">
          <p>
            For account verification purposes, please key in your <strong>FULL NAME and EMAIL according to church records</strong>.
          </p>
          <div>
            <v-form v-model="valid" ref="form">
              <v-layout>
                <v-flex xs4>
                  <v-select v-model="title" :items="titlelist" :rules="titleRules" label="Title" required></v-select>
                </v-flex>
                <v-flex xs8>
                  <v-text-field label="Christian Name (if applicable)" v-model="christianName"></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field label="Family Name" v-model="familyname"></v-text-field>
              <v-text-field label="Given Name or Chinese Name" v-model="givenname"></v-text-field>
              <p class="blue--text">You typed your full name as:<br><strong>{{ renderedname }}</strong></p>
              <v-text-field label="Email Address (as given to the church)" v-model="email" :rules="emailRules"></v-text-field>
              <v-text-field label="Phone Number" v-model="phone" :rules="phoneRules"></v-text-field>
              <v-checkbox label="I have checked that my details are entered correctly" :rules="[v => !!v || 'Check this box to continue']"></v-checkbox>
              <v-text-field label="Password" v-model="password" min="8" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" :rules="passwordRules" counter @click:append="show1 = !show1"></v-text-field>
              <v-text-field label="Confirm password" v-model="passwordconfirmation" min="8" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" :rules="passwordRules" counter @click:append="show2 = !show2"></v-text-field>
              <v-select v-model="membershipStatus" :items="membershipTypeList" :rules="[v => !!v || 'Select an option']" label="Church Membership Status" required></v-select>
              <span v-if="
                    title.length > 0 &&
                      ((christianName.length == 0 && givenname.length == 0) ||
                        (familyname.length == 0 && givenname.length == 0))
                  " class="pt-2 red--text">Please enter your full name</span>
              <span v-else-if="
                    passwordconfirmation.length > 0 &&
                      passwordconfirmation != password
                  " class="pt-2 red--text">Error: Passwords do not match</span>
              <v-btn v-else v-on:click="register" class="blue darken-4 white--text">Register</v-btn>
              <span v-if="displayErrorMessageBool" class="red--text">{{
                  errorMessage
                }}</span>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    renderedname: function () {
      let namebuffer = "";
      namebuffer += this.title + " ";
      if (this.christianName.trim() != "") {
        namebuffer += this.christianName.trim() + " ";
      }
      if (this.familyname.trim() != "") {
        namebuffer += this.familyname.trim() + " ";
      }
      if (this.givenname.trim() != "") {
        namebuffer += this.givenname.trim();
      }
      return namebuffer;
    },
  },
  data() {
    return {
      valid: false,
      show1: false,
      show2: false,
      password: "",
      passwordconfirmation: "",
      passwordRules: [(v) => !!v || "Password is required"],
      username: "",
      usernameRules: [(v) => !!v || "Username is required"],
      email: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Email address is incomplete or contains a space",
      ],
      phone: "",
      phoneRules: [
        (v) =>
          /^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$|^$/.test(v) ||
          "Phone number format is incorrect",
      ],
      title: "",
      titlelist: [
        "Rev",
        "Rev (Dr)",
        "Eld",
        "Eld (Dr)",
        "Dn",
        "Dn (Dr)",
        "Prof",
        "Dr",
        "Mr",
        "Ms",
        "Mrs",
        "Mdm",
        "Master",
        "Miss",
      ],
      titleRules: [(v) => !!v || "Title is required"],
      membershipStatus: "",
      membershipTypeList: [
        "Infant baptised, not reaffirmed",
        "Infant baptised and reaffirmed",
        "Adult baptised in Life BPC",
        "Transferred into Life BPC",
        "Non-member",
      ],
      christianName: "",
      familyname: "",
      givenname: "",
      errorMessage: "",
      displayErrorMessageBool: false,
      ismember: false,
      tcshowdialog: true,
      tcmessage: `
Welcome to Life RTL, the online service of Reformed Tape Library (RTL).
`,
      tcmessagea: `
Life RTL is specially designed for members of Life Bible-Presbyterian Church (Life BPC) to access past recordings of audio, video, photographs, documents and slides that are archived in the RTL, a Life BPC ministry founded in 1978.
`,
      tcmessageb: `
Members will be able to view or listen to the materials online, or to download (only if permitted).
`,
      tcmessagec: `
It is the Design Team’s prayer and desire that the Word of God can reach all church members for the edification and benefit of many souls, till the Lord’s return.
`,
      tcmessage1: `
The Life RTL is open to all members of Life BPC.  All users are required to register with the portal first and then log-in to the user’s account.  Membership with the Life RTL remains as long as the user is a member of Life BPC. No renewal of membership is required for all church members.
`,
      tcmessage1a: `
Special provision is given, at the sole discretion of Life BPC, to non-members (associates) of Life BPC, to obtain a limited Life RTL membership, subject to approval by Life RTL. The associates will be notified by email whether their registration is successful or not. The membership period of associates will last throughout the calendar year. A yearly renewal is required, and this is carried out in the month of January of each new year. If no request for renewal is received from associates, their membership will be terminated by the end of January.
`,
      tcmessage1b: `
All users are responsible for safeguarding the password used to access their accounts. Your account username and login password are strictly non-transferable and not to be disclosed to any third party. You are to inform Life RTL immediately if you believe there is any breach of security such as theft or unauthorized use of your account.
`,
      tcmessage2: `
Access to the Life RTL and usage of the material therein is subject to these terms and conditions. By browsing and logging on to the Life RTL, you accept without qualification these terms and conditions.
`,
      tcmessage2a: `
All members are to use the same name, email address and telephone number (mobile/home) as given to the Church Office during registration. If the member wishes to use a different email address or contact number from the church records, or if any of the information is not given, the member needs to submit the information to the Church Office first before registering for a Life RTL account.
`,
      tcmessage2b: `
All material on Life RTL is intended for the personal use of registered users and must not be copied, reproduced, published, broadcasted, modified, redistributed, disseminated or shared with others.
`,
      tcmessage3: `
The membership of Life RTL will be terminated when the user is no longer a member of Life BPC. Life RTL reserves the right to suspend or terminate a membership, in its sole discretion, and in particular, if the user is found to have violated the Terms of Use, without prior notice or liability.
`,
      tcmessage4: `
The Life RTL design layout and the Terms and Conditions can be subject to change as deemed necessary by Life RTL. No prior notice will be given to the user should there be changes made. The user’s continued use of Life RTL indicates the acceptance of any changes, modifications and revisions made.
`,
      tcmessage5: `
All information given to the Life RTL registration by registered users are at their own will and trust.
`,
      tcmessage5a: `
Life RTL is not responsible for the views, opinions, research and recommendations of any specific media found in the Materials of Life RTL. In particular, Life RTL expressly disclaims all liability, to the extent permitted by the relevant laws, of any content in the Materials which may be offensive, inaccurate, misleading or otherwise objectionable.
`,
      tcmessage5b: `
Life RTL and Life BPC will not be responsible for the loss or theft of any personal information given to the Life RTL in the event of a cyber attack or hacking into the Life RTL system.
`,
      tcmessage5c: `
All content on Life RTL is published with permission from the originator of the content. RTL reserves the right to remove any content on the site without prior notice, upon request from the content owners.
`,
      tcmessage5d: `
These terms and conditions shall be governed by, and construed with, Singapore law. The courts of Singapore shall have exclusive jurisdiction to settle any dispute which may arise out of these terms and conditions.
`,
    };
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$refs.form.$el.submit();
      }
    },
    register: function () {
      if (this.$refs.form.validate()) {
        let password = this.password;
        let phone = this.phone.trim();
        let email = this.email.trim();
        let title = this.title;
        let familyname = this.familyname.trim();
        let givenname = this.givenname.trim();
        let christianName = this.christianName.trim();
        let homephone = this.homephone;
        let membershipStatus = this.membershipStatus;

        let data = {
          username: "",
          password: password,
          phone: phone,
          email: email,
          title: title,
          familyname: familyname,
          givenname: givenname,
          christianname: christianName,
          homephone: homephone,
          membershipstatus: membershipStatus,
        };
        this.$store
          .dispatch("register", data)
          .then(() => this.$router.push("/registersuccess"))
          .catch(() => {
            this.displayErrorMessageBool = true;
            this.errorMessage = "Email address already registered.";
          });
      }
    },
    navigateRoute: function (newpath) {
      this.$router.push(newpath, () => {});
    },
  },
};
</script>

<style>
.loginOverlay {
  background: rgba(33, 150, 243, 0.3);
}
</style>
